<template>
  <div class="privacy-policy">
    <p class="intro">{{ $t('manga.privacy.intro') }}</p>

    <div class="section">
      <h4 class="section-title">{{ $t('manga.privacy.s1Title') }}</h4>
      <p>{{ $t('manga.privacy.s1Content') }}</p>
    </div>

    <div class="section">
      <h4 class="section-title">{{ $t('manga.privacy.s2Title') }}</h4>
      <p>{{ $t('manga.privacy.s2Content') }}</p>
      <ul>
        <li><strong>{{ $t('manga.privacy.s2Item1').split('：')[0] }}：</strong>{{ $t('manga.privacy.s2Item1').split('：').slice(1).join('：') }}</li>
        <li><strong>{{ $t('manga.privacy.s2Item2').split('：')[0] }}：</strong>{{ $t('manga.privacy.s2Item2').split('：').slice(1).join('：') }}</li>
      </ul>
    </div>

    <div class="section">
      <h4 class="section-title">{{ $t('manga.privacy.s3Title') }}</h4>
      <p>{{ $t('manga.privacy.s3Content') }}</p>
      <ul>
        <li><strong>{{ $t('manga.privacy.s3Item1').split('：')[0] }}：</strong>{{ $t('manga.privacy.s3Item1').split('：').slice(1).join('：') }}</li>
        <li><strong>{{ $t('manga.privacy.s3Item2').split('：')[0] }}：</strong>{{ $t('manga.privacy.s3Item2').split('：').slice(1).join('：') }}</li>
      </ul>
    </div>

    <div class="section">
      <h4 class="section-title">{{ $t('manga.privacy.s4Title') }}</h4>
      <p>{{ $t('manga.privacy.s4Content') }}</p>
      <ul>
        <li><strong>{{ $t('manga.privacy.s4Item1').split('：')[0] }}：</strong>{{ $t('manga.privacy.s4Item1').split('：').slice(1).join('：') }}</li>
        <li><strong>{{ $t('manga.privacy.s4Item2').split('：')[0] }}：</strong>{{ $t('manga.privacy.s4Item2').split('：').slice(1).join('：') }}</li>
      </ul>
    </div>

    <div class="section">
      <h4 class="section-title">{{ $t('manga.privacy.s5Title') }}</h4>
      <p>{{ $t('manga.privacy.s5Content') }}</p>
    </div>

    <div class="section">
      <h4 class="section-title">{{ $t('manga.privacy.s6Title') }}</h4>
      <p>{{ $t('manga.privacy.s6Content') }}</p>
    </div>

    <div class="section">
      <h4 class="section-title">{{ $t('manga.privacy.s7Title') }}</h4>
      <p>{{ $t('manga.privacy.s7Content') }}</p>
    </div>

    <div class="section">
      <h4 class="section-title">{{ $t('manga.privacy.s8Title') }}</h4>
      <p>{{ $t('manga.privacy.s8Content') }}</p>
    </div>
  </div>
</template>

<script setup>
</script>

<style scoped>
.privacy-policy {
  color: #cbd5e1;
  line-height: 1.7;
  font-size: 0.95rem;
}

.intro {
  margin-bottom: 1.5rem;
  font-weight: 500;
  color: #e2e8f0;
}

.section {
  margin-bottom: 1.5rem;
}

.section-title {
  color: #5eead4;
  font-size: 1.1rem;
  margin-bottom: 0.8rem;
  font-weight: 600;
}

.privacy-policy p {
  margin-bottom: 0.8rem;
  text-align: justify;
}

.privacy-policy ul {
  margin: 0.8rem 0;
  padding-left: 1.5rem;
}

.privacy-policy li {
  margin-bottom: 0.6rem;
  text-align: justify;
}

.privacy-policy strong {
  color: #5eead4;
  font-weight: 600;
}

@media (max-width: 500px) {
  .privacy-policy {
    font-size: 0.9rem;
  }

  .section-title {
    font-size: 1rem;
  }

  .privacy-policy ul {
    padding-left: 1.2rem;
  }
}
</style>
